import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SeoService { 
  constructor(@Inject(DOCUMENT) private doc: Document) {
  }

  createLinkForCanonicalURL() {

     let ssr: boolean;
     let url: string;
     let link: HTMLLinkElement;

     ssr = typeof window == 'undefined'? true : false;

     if(ssr){
      url = this.doc.URL;
      link = this.doc.createElement('link');
     }else{
      url = window.location.href;
      link = document.querySelector('[rel="canonical"]');
     }

     if(url.indexOf('?') != -1){
        url = url.substring(0, url.indexOf('?'));
     }
     url = url.replace(/\/$/,'');

     link.setAttribute('rel', 'canonical');
     this.doc.head.appendChild(link);
     link.setAttribute('href', url);
   }
} 